import { AdaaHelper } from "../../../../../../../core/utils";
import { commonFormatter, SharedFields } from "../../configs";
import {
  AccordionSectionConfigType,
  ListSectionConfigType,
  ScreenSectionConfigType,
  ScreenType,
} from "../../wf-difference.types";

const typeField: ScreenSectionConfigType = {
  field: "type",
  view: "normal",
  label: "operations_strategic_tasks.type",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "typeName"),
};

const classificationField: ScreenSectionConfigType = {
  field: "classification",
  view: "normal",
  label: "operations_strategic_tasks.classification",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "classificationName"),
};

const priorityHighField: ScreenSectionConfigType = {
  field: "priorityHigh",
  view: "normal",
  label: "operations_strategic_tasks.priority_high",
  format: (data: { priorityHigh: boolean }) => commonFormatter.matchTrueFalse(data?.priorityHigh),
};

const aiConversionEligibilityField: ScreenSectionConfigType = {
  field: "aiConversionEligibility",
  view: "normal",
  label: "operations_strategic_tasks.ai_conversion_eligibility",
  format: (data: { aiConversionEligibility: boolean }) => commonFormatter.matchTrueFalse(data?.aiConversionEligibility),
};

const completionTimeValueField: ScreenSectionConfigType = {
  field: "currentCompletionTimeValue",
  view: "normal",
  label: "operations_strategic_tasks.current_completion_time_value",
};

const completionTimeTypeField: ScreenSectionConfigType = {
  field: "currentCompletionTimeType",
  view: "normal",
  label: "operations_strategic_tasks.current_completion_time_type",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "currentCompletionTimeTypeName"),
};

const responsibilityTypeField: ScreenSectionConfigType = {
  field: "responsibilityType",
  view: "normal",
  label: "operations_strategic_tasks.responsibility_type",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "responsibilityTypeName"),
};

const aiAgentsField: ListSectionConfigType = {
  field: "aiAgents",
  view: "list",
  idKey: "id",
  label: "ai_projects.agents.title",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "name"),
};

const procedureConfig = [
  ...SharedFields.name,
  ...SharedFields.description,
  SharedFields.orgUnitIdField,
  completionTimeValueField,
  completionTimeTypeField,
  responsibilityTypeField,
  aiAgentsField,
];

const proceduresField: AccordionSectionConfigType = {
  view: "accordion",
  field: "procedures",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "name"),
  idKey: "id",
  config: procedureConfig,
  label: "operations_strategic_tasks.procedures",
  hasDiff: ($newValue: unknown, $oldValue: unknown) => {
    const $n = $newValue as Record<string, unknown>;
    const $o = $oldValue as Record<string, unknown>;
    const keys = [
      "nameAE",
      "nameEN",
      "dscAE",
      "dscEN",
      "orgUnitId",
      "currentCompletionTimeValue",
      "currentCompletionTimeType",
      "responsibilityType",
    ];

    return keys.some((key) => $o?.[key] !== $n?.[key]);
  },
};

export const operationsStrategicTasksScreenConfig = {
  type: "simple" as ScreenType,
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    typeField,
    classificationField,
    priorityHighField,
    SharedFields.entityIdField,
    SharedFields.orgUnitIdField,
    SharedFields.ownerField,
    aiConversionEligibilityField,
    proceduresField,
  ],
};
